import { useState, useEffect, useContext } from "react";
import { Row, Col, Form, Container } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "../components/LandingPage.css";
import VN from "../components/VN";
import { UserDataContext } from "../components/UserDataContext";
import "../components/button.css";
import Alerts from "../components/Alerts";
import { TextField, FormControl } from "@mui/material";
import img4 from "../images/Oldpeople.jpg";
import img2 from "../images/logo2.png";
import { marginTop } from "../App";
import { marginBottom } from "../App";
import Button from "@mui/material/Button";
import { apiRequest } from "../components/Config";
import { fetchUserData } from "../components/auth";
import "@fontsource/lato/300.css";
import "@fontsource/lato/400.css";
import "@fontsource/lato/700.css";

const Login = () => {
  const [user, setUser] = useState("");
  const [password, setPassword] = useState("");
  const [apiResponse, setApiResponse] = useState({});
  const navigate = useNavigate();
  const { userData, setUserData } = useContext(UserDataContext);
  const [show, setShow] = useState(false);
  const [showApiResponse, setShowApiResponse] = useState(false);
  const ClearApiResponse = () => {
    setShowApiResponse(false);
  };
  const handleSubmit = async (event) => {
    console.log(event);
    event.preventDefault();
    try {
      const response = await apiRequest("login", "POST", {
        user: user,
        password: password,
      });
      setUserData(response);
      //console.log("response login: ", response);
      const id = response.userId;
      const group = response.group;

      if (response.error_msg === 200) {
        if (group === 1) {
          //console.log("Administrator");
          navigate("/admin");
        }
        if (group === 2) {
          console.log("Weryfikacja");
        }
        if (group === 3) {
          console.log("Opiekunka");
          navigate("/profile");
        }
      }

      if (response.error_msg === 403) {
        setApiResponse({
          title: "Błąd",
          severity: "error",
          info: "Brak uprawnień lub niewłaściwe hasło!",
        });
        setShowApiResponse(true);
      }
      if (response.error_msg === 501) {
        setApiResponse({
          title: "Błąd",
          severity: "error",
          info: "Konto nieaktywne, zablokowane lub nie istnieje!",
        });
        setShowApiResponse(true);
      }
      if (response.error_msg === 502) {
        setApiResponse({
          title: "Ostrzeżenie",
          severity: "warning",
          info: "Nie podano nazwy użytkownika.",
        });
        setShowApiResponse(true);
      }
      if (response.error_msg === 503) {
        setApiResponse({
          title: "Ostrzeżenie",
          severity: "warning",
          info: "Nie podano hasła.",
        });
        setShowApiResponse(true);
      }
    } catch (error) {
      setApiResponse({
        title: "Błąd",
        severity: "error",
        info: "Błąd podczas wysyłania danych.",
      });
      setShowApiResponse(true);
      navigate("/nopermission");
    }
  };

  useEffect(() => {
    const verifyUser = async () => {
      try {
        const userDataAnswer = await fetchUserData();
      } catch (error) {
        console.error("Błąd podczas weryfikacji użytkownika:", error);
      } finally {
      }
    };
    verifyUser();
  }, [navigate, setUserData]);

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      handleSubmit(event);
    }
  };

  const handleShow = () => {
    setShow(!show);
  };

  return (
    <>
      <VN />
      {showApiResponse && (
        <Row style={{ marginBottom }}>
          <Alerts data={apiResponse} />
        </Row>
      )}
      <Container>
        <Form onKeyDown={handleKeyDown}>
          <Row className="align-items-center">
            <Col md="4">
              <img
                src={img2}
                alt="img2"
                style={{
                  width: "100%",
                  height: "auto",
                }}
              />
            </Col>

            <Col xs="auto" style={{ marginRight: 8 }}>
              <FormControl fullWidth>
                <TextField
                  label="Konto"
                  type="text"
                  variant="standard"
                  value={user || ""}
                  onChange={(e) => {
                    setUser(e.target.value);
                    ClearApiResponse();
                  }}
                />
              </FormControl>
            </Col>

            <Col xs="auto" style={{ marginRight: 8 }}>
              <FormControl fullWidth>
                <TextField
                  label="Hasło"
                  type="password"
                  variant="standard"
                  value={password || ""}
                  onChange={(e) => {
                    setPassword(e.target.value);
                    ClearApiResponse();
                  }}
                />
              </FormControl>
            </Col>

            <Col xs="auto">
              <Button variant="outlined" color="success" onClick={handleSubmit}>
                Zaloguj
              </Button>
            </Col>
          </Row>

          <Row className="align-items-center" style={{ marginTop }}>
            <Col md="12" style={{ paddingRight: 8 }}>
              <h1>Bezpieczna opieka dla Twoich rodziców</h1>
            </Col>
          </Row>
        </Form>
        <Row className="align-items-start" style={{ marginBottom }}>
          <Col md="8">
            <h2>
              Wiemy, jak trudno powierzyć bliską osobę komuś obcemu. <br />
              Dlatego każda opiekunka w naszym serwisie przechodzi indywidualną
              weryfikację. <br />
              Sprawdzamy doświadczenie, dokumenty i referencje – abyś miał
              pewność, że Twoi bliscy są w dobrych rękach.
            </h2>
            <br />
            <Button
              variant="contained"
              style={{
                marginBottom: "5%",
                marginLeft: "0%",
                marginRight: "3%",
              }}
            >
              Znajdź zweryfikowaną opiekunkę
            </Button>
            <Button
              variant="outlined"
              style={{ marginBottom: "5%" }}
              onClick={handleShow}
            >
              Sprawdź jak weryfikujemy opiekunki
            </Button>
            {show && (
              <Row>
                <h2>
                  Każda opiekunka jest dokładnie sprawdzana.
                  <br /> To, co nas wyróżnia, to rzetelna weryfikacja każdej
                  osoby, zanim pojawi się w serwisie.
                  <br /> Sprawdzamy między innymi:
                  <br />
                  <br /> ✔ tożsamość <br />✔ doświadczenie w opiece nad
                  seniorami <br />✔ referencje od poprzednich rodzin <br />✔
                  kwalifikacje i kursy <br />✔ prowadzimy rozmowę weryfikacyjną{" "}
                  <br />
                  <br />
                  Dzięki temu masz pewność, że korzystasz tylko ze sprawdzonych
                  opiekunek.
                </h2>
              </Row>
            )}
          </Col>
          <Col md="4">
            <div
              style={{
                background: "#f6f1e7",
                padding: 2,
                border: "3px solid #a8a08d",
                boxShadow: "0 6px 12px rgba(0,0,0,0.25)",
                display: "inline-block",
              }}
            >
              <img
                src={img4}
                alt="img4"
                style={{
                  width: "100%",
                  height: "auto",
                  display: "block",
                  border: "3px solid #fff",
                }}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Login;
